module.exports = __webpack_public_path__ + "static/media/mn7.f432377b.jpeg";